import { CurrentUser, Id, ListState, OrganizationInvite, OrganizationJoinRequest, OrganizationUser, PaginationJSON, SuccessResponse, User } from '../types';
import { abibApi, tags, methods } from './';

// '/users': {
//     '/': 'get', // getAllUsers
//     '/': 'post', // createUser
//     '/{user}': 'get', // getUser
//     '/{user}': 'put', // updateUser
//     '/{user}': 'delete', // deleteUser

//     '/{user}/assignGlobalRole/{globalRole}': 'put', // assignGlobalRole
//   };
const apiUsers = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query<ListState<User, void>, { perPage?: number, page?: number }>({
      query: ({ page = 1, perPage = 20 }) => {
        return {
          method: methods.GET,
          url: `/users?page=${page}&perPage=${perPage}`,
        };
      },
      providesTags: (result, error, arg) => [{ type: tags.userList }],
      transformResponse: (response: { data?: User[], meta?: PaginationJSON }, meta, arg) => ({
        items: response.data ?? [],
        pagination: response.meta,
      }),
    }),
    createUser: builder.mutation<SuccessResponse, User>({
      query: (user) => {
        return {
          method: methods.POST,
          url: `/users`,
          body: user,
        };
      },
      invalidatesTags: (result, error, user) => [{ type: tags.userList }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    getUser: builder.query<User, { user_id: Id }>({
      query: ({ user_id }) => {
        return {
          method: methods.GET,
          url: `/users/${user_id}`,
        };
      },
      providesTags: (result, error, { user_id }) => [{ type: tags.user, user_id }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    updateUser: builder.mutation<User, { user_id: Id, user: Partial<User> }>({
      query: ({ user_id, user }) => {
        return {
          method: methods.PUT,
          url: `/users/${user_id}`,
          body: user,
        };
      },
      invalidatesTags: (result, error, { user_id, user }) => [tags.userList, { type: tags.user, user_id }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    deleteUser: builder.mutation<SuccessResponse<void>, { user_id: Id }>({
      query: ({ user_id }) => {
        return {
          method: methods.DELETE,
          url: `/users/${user_id}`,
        };
      },
      invalidatesTags: (result, error, { user_id }) => [tags.userList, { type: tags.user, user_id }],
    }),
    assignGlobalRole: builder.mutation<SuccessResponse<void>, { user_id: Id, global_role_id: Id }>({
      query: ({ user_id, global_role_id }) => {
        return {
          method: methods.PUT,
          url: `/users/${user_id}/assignGlobalRole/${global_role_id}`,
        };
      },
      invalidatesTags: (result, error, { user_id, global_role_id }) => [tags.userList, { type: tags.user, user_id }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllUsersQuery,
  useCreateUserMutation,
  useGetUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useAssignGlobalRoleMutation,
} = apiUsers;
